import router from "../pc/router";
import install from "../pc";
import "../assets/styles/pc/index.scss";

dsf.setupModule(function () {
  Vue.use(install);
  dsf.router.add(router, "pc");
});
